//@flow

import React from 'react';
import type { Node } from 'react';

type State = { on: boolean };

type ChildrenArgs = {
  on: boolean,
  open: () => void,
  close: () => void,
  toggle: () => void,
};

type Props = { children: (args: ChildrenArgs) => Node, initialOn?: boolean };

export default class Toggler extends React.Component<Props, State> {
  state = { on: this.props.initialOn || false };

  toggle = () => this.setState(({ on }) => ({ on: !on }));

  open = () => this.setState(() => ({ on: true }));

  close = () => this.setState(() => ({ on: false }));

  render() {
    return this.props.children({
      toggle: this.toggle,
      on: this.state.on,
      open: this.open,
      close: this.close,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/Toggler.jsx